import { Model } from '@/models/Model';
export class LvsPeriod extends Model {
    constructor() {
        super(...arguments);
        this.$name = 'LvsPeriod';
        this.$endpoint = '/lvs-periods';
        this.$fillable = ['name', 'level'];
    }
}
